(() => {
  const article = document.querySelector('[data-legal-policy]');
  if (!article) return;
  const body = article.querySelector('.legal-policy-body');
  if (!body || !body.textContent.trim()) return;
  // Move the existing policy nodes, retaining every word, list, and link.
  const nodes = [...body.childNodes];
  const sections = [];
  let section;
  const createSection = (heading) => {
    section = document.createElement('section');
    section.id = `policy-section-${sections.length + 1}`;
    heading.id = `${section.id}-title`;
    section.setAttribute('aria-labelledby', heading.id);
    section.append(heading);
    sections.push(section);
    return section;
  };
  const makeHeading = (text) => {
    const heading = document.createElement('h2');
    heading.textContent = text;
    heading.dataset.policyAdded = '';
    return heading;
  };
  for (const node of nodes) {
    if (node.nodeType === Node.ELEMENT_NODE && /^H[1-4]$/.test(node.tagName)) {
      const heading = document.createElement('h2');
      while (node.firstChild) heading.append(node.firstChild);
      node.replaceWith(heading);
      createSection(heading);
    } else if (article.dataset.legalPolicy === 'contact' && node.nodeName === 'HR' && sections.length === 1) {
      createSection(makeHeading(article.dataset.contactLabel));
      section.append(node);
    } else {
      if (!section) {
        if (!node.textContent.trim() && node.nodeType === Node.TEXT_NODE) continue;
        createSection(makeHeading(article.dataset.legalPolicy === 'contact' ? article.dataset.addressLabel : article.dataset.overviewLabel));
      }
      section.append(node);
    }
  }
  body.replaceChildren(...sections);
  const nav = document.createElement('nav');
  nav.className = 'legal-contents';
  nav.setAttribute('aria-label', article.dataset.contentsLabel);
  const label = document.createElement('p');
  label.textContent = article.dataset.contentsLabel;
  nav.append(label);
  sections.forEach(section => {
    const link = document.createElement('a');
    link.href = `#${section.id}`;
    link.textContent = section.querySelector('h2').textContent.trim();
    nav.append(link);
  });
  body.before(nav);
  article.classList.add('legal-policy-ready');
})();
